export function Hr(): JSX.Element {
    return <hr className="my-2 dark:border-gray-200 border-gray-300 w-full" />
}
